import { NgModule } from '@angular/core';
import { HttpModule } from '../public_api';

@NgModule({
  declarations: [],
  imports: [HttpModule],
})
export class D3DocumentRepositoryModule {}
